export enum PostHogEvent {
	BLACK_FRIDAY_BANNER_DISPLAYED = 'black_friday_banner_displayed',
	BLACK_FRIDAY_BANNER_DISMISSED = 'black_friday_banner_dismissed',
	BLACK_FRIDAY_MODAL_OPENED = 'black_friday_modal_opened',
	BLACK_FRIDAY_CLAIM_FAILED = 'black_friday_claim_failed',
	HEADER_KNOWLEDGE_BASE = 'header_knowledge_base',
	HEADER_NOTIFICATIONS = 'header_notifications',

	PAGEVIEW_ANALYTICS = 'pageview_analytics',
	PAGEVIEW_DASHBOARD = 'pageview_dashboard',
	PAGEVIEW_CLICKS = 'pageview_clicks',
	PAGEVIEW_THREAT = 'pageview_threat',
	PAGEVIEW_EXCLUSIONS = 'pageview_exclusions',
	PAGEVIEW_BLACKLIST = 'pageview_blacklist',
	PAGEVIEW_RULES = 'pageview_rules',
	PAGEVIEW_SECURITY = 'pageview_security',
	PAGEVIEW_AUTHORIZATIONS = 'pageview_authorizations',
	PAGEVIEW_AD_ACCOUNTS = 'pageview_ad_accounts',
	PAGEVIEW_SCHEDULED_REPORTS = 'pageview_scheduled_reports',
	PAGEVIEW_PROTECTION = 'pageview_protection',
	PAGEVIEW_REFUNDS_AGENT = 'pageview_refunds_agent',
	PAGEVIEW_CUSTOM_RULES = 'pageview_custom_rules',
	PAGEVIEW_AI_PROTECTION = 'pageview_ai_protection',

	EXPORT_REQUEST = 'export_request',
	EXPORT_DOWNLOAD = 'export_download',
	EXPORT_SUCCESSFUL = 'export_successful',
	LIVE_MONITORING = 'live_monitoring',

	CHART_CHANGE_FILTER = 'chart_change_filter',
	ADD_BLACKLIST_ENTITY = 'add_blacklist_entity',

	SCHEDULE = 'schedule',
	SCHEDULE_REPORT = 'schedule_report',
	RUN = 'run',
	DOWNLOAD = 'download',
	// Analytics Report monitoring (DEV-2377). `pageview` fires per tab.
	PAGEVIEW = 'pageview',
	PAGEVIEW_LEGACY = 'pageview_legacy',

	SEND_TRACKING_CODE_EMAIL = 'tc_email_my_developer',
	SEND_DNS_EMAIL = 'dns_email_my_developer',

	ADD_CUSTOM_RULE = 'add_custom_rule',
	// DEV-2403 §5. Templates are a new capability with no existing event to
	// reuse; these follow the naming of the two above.
	SAVE_RULE_TEMPLATE = 'save_rule_template',
	USE_RULE_TEMPLATE = 'use_rule_template',
	SAVE_AI_PROTECTION_SETTINGS = 'save_ai_protection_settings',
	CLICK_ANALYZE_TAB = 'click_analysis_tab',
	ADD_MEMBER = 'add_member',
	LINK_KNOWLEDGE_BASE = 'link_knowledge_base',
	UPDATE_PAYMENT = 'update_payment',
	PAYMENT_DUE = 'payment_due',
	RETRY_PAYMENT = 'retry_payment',

	UPGRADE_INTEREST = 'upgrade_interest',
	UPGRADE_CONFIRMATION = 'upgrade_confirmation',
	CANCEL_INTENT = 'cancel_intent',
	CANCEL_PROCEED = 'cancel_proceed',
	CANCEL_RETURN = 'cancel_return',

	SELECT_PLAN_REGULAR = 'select_plan_regular',
	SELECT_PLAN_CUSTOM_QUOTE = 'select_plan_custom_quote',
	START_TRIAL = 'start_trial',
	BANNER_IMPRESSION = 'banner_impression',
	CTA_CLICK = 'cta_click',

	INTENT = 'intent',
	ACTIVATE = 'activate',

	UPGRADE_INTENT = 'upgrade_intent',
	UPGRADE_SUCCESSFUL = 'upgrade_successful',

	CLICK_COMPONENT = 'click_component',
	// Onboarding events
	ONBOARDING_CONTACT_SUPPORT_ICON = 'contact_support_icon',
	ONBOARDING_CONTACT_SUPPORT_CTA = 'contact_support_cta',
	ONBOARDING_SELECT_PLAN = 'select_plan',
	ONBOARDING_START_TRIAL = 'start_trial',
	ONBOARDING_WATCH_TUTORIAL = 'watch_tutorial',
	ONBOARDING_BOOK_ONBOARDING_CALL = 'book_onboarding_call',
	ONBOARDING_KNOWLEDGE_BASE = 'knowledge_base',
	ONBOARDING_INVITE_MEMBER = 'invite_member',
	ONBOARDING_COMPLETE_AD_ACCOUNT_STEP = 'complete_ad_account_step',
	ONBOARDING_COMPLETE_TC_STEP = 'complete_tc_step',
	ONBOARDING_EMAIL_DEVELOPER = 'email_developer',
	ONBOARDING_SKIP_TO_DASHBOARD = 'skip_to_dashboard',
	ONBOARDING_BANNER_OPEN = 'banner_open',
	ONBOARDING_BANNER_CLICK_CONTINUE_SETUP = 'banner_click_continue_setup',
	ONBOARDING_BANNER_SKIP_TC = 'banner_skip_tc',
	ONBOARDING_TRY_NEW_AUTH = 'try_new_auth',

	// Cancellation banner events
	RESUME_PLAN = 'resume_plan',

	// Inactive tracking code banner events
	INACTIVE_TC_BANNER_SHOWN = 'inactive_tc_banner_shown',
	INACTIVE_TC_VERIFICATION_STARTED = 'inactive_tc_verification_started',
	INACTIVE_TC_VERIFICATION_SUCCESS = 'inactive_tc_verification_success',
	INACTIVE_TC_VERIFICATION_FAILED = 'inactive_tc_verification_failed',

	// No subscription events
	NO_SUBSCRIPTION_CTA_INTERACTIVE_DEMO = 'cta_interactive_demo',
	NO_SUBSCRIPTION_CTA_ACTIVATE = 'cta_activate',
	NO_SUBSCRIPTION_START_INTERACTIVE_DEMO = 'start_interactive_demo',

	// Email deeplink trial extension events
	VIEW_POP_UP = 'view_pop_up',
	ACCEPTED = 'accepted',
	SCHEDULE_WITH_CSM = 'schedule_with_csm',

	// + Button (Adoption Actions)
	CREATE_NEW_BUTTON = 'create_new_button',

	// DEV-2339 · Account Overview (T13) — fired with path ACCOUNT_OVERVIEW.
	ACCOUNT_OVERVIEW_PAGEVIEW = 'pageview',
	ACCOUNT_OVERVIEW_CLICK_CARD_FILTER = 'click_card_filter'
}

export enum PostHogPath {
	GLOBAL = 'null',
	ANALYTICS = 'analytics',
	// Analytics Report event paths (DEV-2377).
	ANALYTICS_REPORTS = 'analytics_reports',
	SCHEDULED_REPORTS_TAB = 'scheduled_reports',
	DASHBOARD = 'dashboard',
	CLICKS = 'clicks',
	THREAT = 'threat',
	EXCLUSIONS = 'exclusions',
	SCHEDULED_REPORTS = 'scheduledreports',
	BLACKLIST = 'blacklist',
	AUTHORIZATIONS = 'authorizations',
	AD_ACCOUNTS = 'ad_accounts',
	REFUNDS_AGENT = 'refunds_agent',
	SETTINGS_RULES = 'settings_rules',
	AI_AND_CUSTOMRULES = 'ai_and_customrules',
	/** DEV-2403's page. `AI_AND_CUSTOMRULES` stays the old page's path. */
	CUSTOM_RULES = 'custom_rules',
	/** DEV-2422's page, the other half of the same split. */
	AI_PROTECTION = 'ai_protection',
	SETTINGS_SECURITY = 'settings_security',
	SETTINGS_BILLING = 'settings_billing',
	SETTINGS_TEAM_ACCESS = 'settings_teamaccess',
	SETTINGS_TC = 'settings_tc',
	SETTINGS_PAYMENT_METHOD = 'settings_paymentmethod',
	FAILED_PAYMENT = 'failed_payment',
	ACCOUNT_CREATION = 'account_creation',
	SETUP = 'setup',
	AFFILIATE = 'affiliate',
	CC_EXPIRATION_BANNER = 'cc_expiration_banner',
	PROTECTION = 'protection',
	UPGRADE_PLAN_BANNER = 'upgrade_plan_banner',
	ONBOARDING = 'onboarding',
	NO_SUBSCRIPTION = 'no_subscription',
	BANNER = 'banner',
	EMAIL_DEEPLINK_TRIAL_EXTENSION = 'email_deeplink_trial_extension',

	// DEV-2339 · Account Overview (T13)
	ACCOUNT_OVERVIEW = 'account_overview'
}
